import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { DefectTabs } from "../../types/DefectTabs";
import { classNames } from "primereact/utils";
import { useCallback, useMemo } from "react";
import { setActiveTab } from "../../store/slices/defectSlice";
import { FilterMatchMode } from "primereact/api";
import { getDefectSummaryAggregates } from "./DefectsSummaryDataHelper";
import { resetTableFilters } from "../../store/thunks/filtersThunks";
import { getSummaryTableLinkConfig } from "../../utils/DefectsSummaryTableDataHelper";
import { selectIsTechManager } from "../../store/selectors/userSelectors";
import { DefectPriority } from "../../types/DefectPriority";

export const DefectSummaryAggregates = (props: any) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation("locale");

    const { defectAggregates } = props;
    const isTechManager = useAppSelector(selectIsTechManager);
    const { tableKey, defaultConfig, priorityField, statusField } = getSummaryTableLinkConfig(isTechManager);

    const aggregates = useMemo(() => 
        getDefectSummaryAggregates(defectAggregates)
    , [defectAggregates]);

    const onClickDefectsTotal = useCallback(() => {
    if (aggregates.defectsTotal) {
            dispatch(resetTableFilters(tableKey, {
                ...defaultConfig,
                [statusField]: { value: [], matchMode: FilterMatchMode.IN }
            }));
            dispatch(setActiveTab(DefectTabs.defects));
        }
    }, [aggregates.defectsTotal]);

    const onClickHighPriorityTotal = useCallback(() => {
        if (aggregates.highPriorityTotal) {
            dispatch(resetTableFilters(tableKey, { 
                ...defaultConfig,
                [priorityField]: { value: [DefectPriority.high], matchMode: FilterMatchMode.IN },
                [statusField]: { value: [], matchMode: FilterMatchMode.IN }
            }));
            dispatch(setActiveTab(DefectTabs.defects));
        }
    }, [aggregates.highPriorityTotal]);

    const onClickMediumPriorityTotal = useCallback(() => {
        if (aggregates.mediumPriorityTotal) {
            dispatch(resetTableFilters(tableKey, { 
                ...defaultConfig,
                [priorityField]: { value: [DefectPriority.medium], matchMode: FilterMatchMode.IN },
                [statusField]: { value: [], matchMode: FilterMatchMode.IN }
            }));
            dispatch(setActiveTab(DefectTabs.defects));
        }
    }, [aggregates.mediumPriorityTotal]);

    const onClickLowPriorityTotal = useCallback(() => {
        if (aggregates.lowPriorityTotal) {
            dispatch(resetTableFilters(tableKey, { 
                ...defaultConfig,
                [priorityField]: { value: [DefectPriority.low], matchMode: FilterMatchMode.IN },
                [statusField]: { value: [], matchMode: FilterMatchMode.IN }
            }));
            dispatch(setActiveTab(DefectTabs.defects));
        }
    }, [aggregates.lowPriorityTotal]);
    
    return (
        <div className="grid flex mt-3 mr-0 ml-0 mb-3 gap-3">
            <div className="col-4 md:col p-0">
                <span className="defects-aggregate-label">{t("defectsSummary.defectsTotal")}</span>
                <span 
                    className={classNames(aggregates.defectsTotal ? "cursor-pointer read-more-btn underline" : "font-normal", "defects-aggregate-count mt-1")}
                    onClick={onClickDefectsTotal}
                >
                    {aggregates.defectsTotal}
                </span>
            </div>
            <div className="col-4 md:col p-0">
                <span className="defects-aggregate-label">{t("defectsSummary.highPriorityTotal")}</span>
                <span 
                    className={classNames(aggregates.highPriorityTotal ? "cursor-pointer read-more-btn underline" : "font-normal", "defects-aggregate-count mt-1")}
                    onClick={onClickHighPriorityTotal}
                >
                    <img src="/high.svg" className="priority-icon-size-small m-auto" />
                    <span className="flex-1 text-center">{aggregates.highPriorityTotal}</span>
                </span>
            </div>
            <div className="col-4 md:col p-0">
                <span className="defects-aggregate-label">{t("defectsSummary.mediumPriorityTotal")}</span>
                <span
                    className={classNames(aggregates.mediumPriorityTotal ? "cursor-pointer read-more-btn underline" : "font-normal", "defects-aggregate-count mt-1")}
                    onClick={onClickMediumPriorityTotal}
                >
                    <img src="/medium.svg" className="priority-icon-size-small m-auto" />
                    <span className="flex-1 text-center">{aggregates.mediumPriorityTotal}</span>
                </span>
            </div>
            <div className="col-4 md:col p-0">
                <span className="defects-aggregate-label">{t("defectsSummary.lowPriorityTotal")}</span>
                <span
                    className={classNames(aggregates.lowPriorityTotal ? "cursor-pointer read-more-btn underline" : "font-normal", "defects-aggregate-count mt-1")}
                    onClick={onClickLowPriorityTotal}
                >
                    <img src="/low.svg" className="priority-icon-size-small m-auto" />
                    <span className="flex-1 text-center">{aggregates.lowPriorityTotal}</span>
                </span>
            </div>
        </div>
    )
};